import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OpportunityTalentsList = _resolveComponent("OpportunityTalentsList")!
  const _component_app_loader_opportunities = _resolveComponent("app-loader-opportunities")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.opportunities, (opp) => {
      return (_openBlock(), _createBlock(_component_OpportunityTalentsList, {
        key: `opp-${opp._id}`,
        opportunity: opp
      }, null, 8, ["opportunity"]))
    }), 128)),
    _createVNode(_component_app_loader_opportunities, {
      loading: _ctx.loading,
      resources: _ctx.opportunities,
      content: "Can't find any opportunities to match with."
    }, null, 8, ["loading", "resources"])
  ]))
}